<template>
	<span>{{formatedMontant}}</span>
</template>
<script>
	export default{
		props: {
			montant:{
				type: String|Number
			},
		},
		computed: {
			formatedMontant: function () {
				if(!this.montant && this.montant!=0) return;
				let options = {style:'currency', currency:'EUR'};
				return parseFloat(this.montant).toLocaleString('fr-FR', options);
			},
		},
	}
</script>